import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface ListQueryParams {
  group_id: number
  key_word?: string
  page: number
  limit: number
  soft_hash_key?: string
  soft_name: string
}

export interface ClientInfo {
  device_id: string
  computer_name: string
  user_mark: string
  client_ip: string
  system_ip: string
  version: string
  login_status?: number
  system_type?: number
  soft_hash_key: string
}

export interface UninstallListItem {
  device_id?: string
  soft_hash_key: string
}

export interface SoftwareUninstallParams {
 /** 卸载类型,0-提醒卸载，1-启动卸载 */
  uninstall_type: number
  /** 0-指定终端，1-全部 */
  execute_type?: number
  /** 终端id集合 */
  uninstall_list?: UninstallListItem[]
}

@Injectable()
export class InstalledDetailService {
  constructor (private http: Http) {}

  @ParamsClean()
  @InvokeThrottle()
  getTerminalList (params: Partial<ListQueryParams>) {
    return this.http.post<{
      total: number
      list: ClientInfo[]
    }>('/softmgr/terminal/list', params)
  }

  download (type: 0|1, options: ListQueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0,
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/terminal/list/export', params, moduleName)
  }

  uninstallSoftware (params: SoftwareUninstallParams) {
    return this.http.post('/terminal-order/soft-uninstall', params)
  }
}
